import React from "react";

function PromotedDealContainer() {
  return (
    <div className="promoted-deal-container">
      <a
        href="https://www.google.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://static.vecteezy.com/system/resources/previews/002/041/568/original/big-sale-banner-template-promotion-with-phone-digital-marketing-concept-vector.jpg"
          alt="https://static.vecteezy.com/system/resources/previews/002/041/568/original/big-sale-banner-template-promotion-with-phone-digital-marketing-concept-vector.jpg"
        />
      </a>
      >
    </div>
  );
}

export default PromotedDealContainer;
